module.exports = __webpack_public_path__ + "static/img/img-honor5.e743195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-honor5.png
// module id = Cnr8
// module chunks = 1